import { updateIntl } from 'react-intl-redux'
import { loadMessages } from './index'

export const changeLocale = (locale) => (dispatch) => {
    const messages = loadMessages(locale)
    dispatch(updateIntl({
        locale,
        messages
    }))
}